export const DEFAULT_PROPS_CANCEL_BUTTON = {
  label: 'Cancel',
  hidden: false,
}
